<template>
  <div>
    <div
      class="button-container"
      v-if="videos.list.length > 1"
    >
      <div
        class="button-item"
        :class="TextDecoderStream == item.langue ? 'is-active': ''"
        v-for="item in videos.list"
        :key="item.langue"
        @click="changeVideoId(item)"
      >
        {{ item.langue }}
      </div>
    </div>
    <div
      class="video-wrapper"
      :class="{ 'vodalys' : displayVodalys }"
    >
      <button
        class="btn-play"
        @click="showVideo"
      >
        <svg class="icon icon-media-video"><use xlink:href="#icon-media-video"></use></svg>
      </button>
      <img :src="imageUrl">
      <template v-if="!verifyImageUrl || videoAppear">
        <iframe
          v-if="isVodalys && typePlayer == 'vodalys'"
          width="1280"
          height="720"
          :src="`https://console.vodalys.studio/p/${currentVideo}#?embedded=true`"
          allowfullscreen="true"
          frameborder="0"
        />

        <video-player
          :options="videoOptions"
          v-if="isVodalys && typePlayer == 'm3u'"
        />

        <iframe
          v-if="typePlayer == 'iframe'"
          width="1280"
          height="720"
          :src="videoIframe"
          allowfullscreen="true"
          frameborder="0"
        />


        <youtube
          v-if="!isVodalys"
          @ready="onReady"
          :video-id="currentVideo"
          :player-vars="videos.params"
          ref="youtube"
        />
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Youtube } from 'vue-youtube';
import VideoPlayer from './Media/VideoPlayer.vue';

export default {
  components: {
    Youtube,
    VideoPlayer,
  },
  props: {
    videos: {
      type: Object,
      required: true,
    },
    typePlayer: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    displayVodalys: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      TextDecoderStream: null,
      videoAppear: false,
      currentVideo: '',
      isVodalys: false,
      isVodalysType: false,
      sourceItem: '',
      videoIframe: null,
      videoOptions: {
        autoplay: true,
        controls: true,
        poster: true,
        sources: [
          {
            src:
            this.currentVideo,
          },
        ],
      },
    }
  },
  beforeMount() {
    this.updateIsVodalys();
  },

  computed: {
    player() {
      return this.$refs.youtube.player
    },
    verifyImageUrl() {
      return this.imageUrl.length > 0
    },

  },
  methods: {

    async updateIsVodalys() {
      const newAjaxUrl = `${this.displayVodalys}`;
      try {
        axios.get(newAjaxUrl).then((response) => this.assignVar(response));
      } catch (error) {
        console.log(error)
      }
    },
    assignVar(response) {
      this.isVodalys = response.data.data.filtered;
      this.TextDecoderStream = this.videos.list[0].langue;
      if (this.typePlayer === 'iframe') {
        this.videoIframe = this.videos.list[0].url_stream_only
      }
      if (this.isVodalys) {
        this.currentVideo = this.typePlayer === 'vodalys' ? this.videos.list[0].id_vodalys : this.videos.list[0].url_m3u;
        if (this.typePlayer === 'm3u') {
          this.videoOptions.sources[0].src = this.videos.list[0].url_m3u;
        }
      } else {
        this.currentVideo = this.videos.list[0].id_youtube;
      }
    },
    showVideo() {
      this.videoAppear = true;
    },
    async onReady() {
      await this.player.playVideo();
    },
    changeVideoId(item) {
      this.TextDecoderStream = item.langue;
      if (this.typePlayer === 'iframe') {
        this.videoIframe = item.url_stream_only
      }
      if (this.isVodalys) {
        this.currentVideo = this.typePlayer === 'vodalys' ? item.id_vodalys : item.url_m3u;
        if (this.typePlayer === 'm3u') {
          this.videoOptions.sources[0].src = item.url_m3u;
        }
      } else {
        this.currentVideo = item.id_youtube;
      }
    },
  },
}
</script>

<style scoped>

</style>
